export default __webpack_public_path__ + "static/media/certificate_NPTEL.2196d13a.WebP";